<div class="p-2">
    <div class="sub-bg">
        <div class="container-fluid">
            <div class="form-group row">
                <form [formGroup]="formdata" autocomplete="off">
                    <div class="row mt-3">
                        <!-- Company -->
                        <div class="col-md-3" *ngIf="!hideCompany">
                            <label class="form-label required" for="company_id">Company</label>
                            <ng-select [items]="companyList" bindLabel="company_name" bindValue="id" [clearable]="false"
                                placeholder="Select Company" formControlName="company_id"
                                [ngClass]="{ 'is-invalid': isInvalid('company_id') }"
                                (change)="onCompanyChange($event)">
                            </ng-select>
                            <div *ngIf="isInvalid('company_id')" class="invalid-feedback">
                                <span *ngIf="formdata.get('company_id')?.errors?.['required']">
                                    Company is required.
                                </span>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label required">Employee</label>
                            <ng-select formControlName="employee_id" placeholder="Select Employee" [clearable]="false"
                                [ngClass]="{ 'is-invalid': isInvalid('employee_id') }"
                                (change)="onEmployeeChange($event)">

                                <ng-option *ngFor="let item of employeeList" [value]="item.id">
                                    {{ item.firstname }} {{ item.lastname }} - {{ item?.employeecode }}
                                </ng-option>
                            </ng-select>

                            <div *ngIf="isInvalid('employee_id')" class="invalid-feedback">
                                <span *ngIf="formdata.get('employee_id')?.errors?.['required']">
                                    Employee is required.
                                </span>
                            </div>
                        </div>

                        <!-- Start Date -->
                        <div class="col-sm-3">
                            <label class="form-label required">Start Date</label>
                            <div>
                                <p-calendar *ngIf="renderCalendar" formControlName="start_date"
                                    [dateFormat]="dateFormat" [iconDisplay]="'input'" touchUI="true" [showIcon]="true"
                                    styleClass="custom-calendar" inputId="icondisplay"
                                    (onSelect)="onDateChange($event ,'start_date')"
                                    [ngClass]="{ 'is-invalid': isInvalid('start_date') }">
                                </p-calendar>
                                <div *ngIf="isInvalid('start_date')" class="invalid-feedback">
                                    <span *ngIf="formdata.get('start_date')?.errors?.['required']"> Start Date is
                                        required.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- End Date -->
                        <div class="col-sm-3">
                            <label class="form-label required">End Date</label>
                            <div>
                                <p-calendar *ngIf="renderCalendar" formControlName="end_date" [dateFormat]="dateFormat"
                                    [iconDisplay]="'input'" touchUI="true" [showIcon]="true"
                                    styleClass="custom-calendar" inputId="icondisplay"
                                    (onSelect)="onDateChange($event ,'end_date')"
                                    [ngClass]="{ 'is-invalid': isInvalid('end_date') }"
                                    [minDate]="formdata.value.start_date" [defaultDate]="formdata.value.start_date">
                                </p-calendar>
                                <div *ngIf="isInvalid('end_date')" class="invalid-feedback">
                                    <span *ngIf="formdata.get('end_date')?.errors?.['required']"> End Date is required.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- Comments -->
                        <div class="col-md-3"
                            *ngIf="viewData?.status == 'Approved' || viewData?.status == 'Rejected' || viewData?.status == 'Cancelled'">
                            <label class="form-label">Comments</label>
                            <textarea type="text" class="form-control" [readOnly]="true" maxlength="255"
                                formControlName="comments" placeholder="Enter Comments"
                                [ngClass]="{ 'is-invalid': isInvalid('comments') }"></textarea>
                            <div *ngIf="isInvalid('comments')" class="invalid-feedback">
                                <span *ngIf="formdata.get('comments')?.errors?.['required']">
                                    Comments is required
                                </span>
                            </div>
                        </div>
                        <!-- Attendance Table -->
                        <div class="mt-3 col-sm-12" *ngIf="sections.length > 0">
                            <table class="table table-bordered table-reqularization px-3">
                                <thead>
                                    <tr>
                                        <th class="tHead">Date</th>
                                        <th class="tHead">Status</th>
                                        <th class="tHead">Shift Time</th>
                                        <th class="tHead required">Check-In Time</th>
                                        <th class="tHead required">Check-Out Time</th>
                                        <th class="tHead required">Comments</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="sections">
                                    <tr *ngFor="let section of sections.controls; let i = index" [formGroupName]="i">
                                        <td>{{ section.get('calendar_date')?.value | date: angularDateFormat }}</td>
                                        <td>{{ section.get('status')?.value ? section.get('status')?.value : '---'
                                            }}</td>
                                        <td>{{ section.get('shift_time')?.value ? section.get('shift_time')?.value :
                                            '---' }}</td>
                                        <td>
                                            <ng-container
                                                *ngIf="section.get('status')?.value === 'Leave Approved' || section.get('status')?.value === 'Leave Request Pending'">
                                                ---
                                            </ng-container>
                                            <ng-container
                                                *ngIf="section.get('status')?.value !== 'Leave Approved' && section.get('status')?.value !== 'Leave Request Pending'">
                                                <div class="custom-timepicker">
                                                    <div class="input-group">
                                                        <input class="form-control"
                                                            [ngClass]="{ 'is-invalid': (saveClick && section.get('checkin_time')?.errors) || (section.get('checkin_time')?.invalid && (section.get('checkin_time')?.dirty || section.get('checkin_time')?.touched)) }"
                                                            formControlName="checkin_time"
                                                            [ngxTimepicker]="startTimePicker" placeholder="Select time"
                                                            readonly>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" type="button"
                                                                [disabled]="section.get('checkin_time')?.disabled"
                                                                (click)="startTimePicker.open()">
                                                                <i class="fa-regular fa-clock"></i>
                                                            </button>
                                                        </div>
                                                        <div *ngIf="section.get('checkin_time')?.invalid && (section.get('checkin_time')?.dirty || section.get('checkin_time')?.touched || saveClick)"
                                                            class="invalid-feedback">
                                                            <span class="d-flex"
                                                                *ngIf="section.get('checkin_time')?.errors?.['required']">Select
                                                                Check-In Time</span>
                                                        </div>
                                                    </div>
                                                    <ngx-material-timepicker #startTimePicker [format]="24"
                                                        (timeSet)="section.get('checkin_time') && onTimeChange($event, section.get('checkin_time')!)">
                                                    </ngx-material-timepicker>
                                                </div>
                                            </ng-container>
                                        </td>
                                        <td>
                                            <ng-container
                                                *ngIf="section.get('status')?.value === 'Leave Approved' || section.get('status')?.value === 'Leave Request Pending'">
                                                ---
                                            </ng-container>
                                            <ng-container
                                                *ngIf="section.get('status')?.value !== 'Leave Approved' && section.get('status')?.value !== 'Leave Request Pending'">
                                                <div class="custom-timepicker">
                                                    <div class="input-group">
                                                        <input class="form-control"
                                                            [ngClass]="{ 'is-invalid': (saveClick && section.get('checkout_time')?.errors) || (section.get('checkout_time')?.invalid && (section.get('checkout_time')?.dirty || section.get('checkout_time')?.touched)) }"
                                                            formControlName="checkout_time"
                                                            [ngxTimepicker]="endTimePicker" placeholder="Select time"
                                                            readonly>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" type="button"
                                                                [disabled]="section.get('checkout_time')?.disabled"
                                                                (click)="endTimePicker.open()">
                                                                <i class="fa-regular fa-clock"></i>
                                                            </button>
                                                        </div>
                                                        <div *ngIf="section.get('checkout_time')?.invalid && (section.get('checkout_time')?.dirty || section.get('checkout_time')?.touched || saveClick)"
                                                            class="invalid-feedback">
                                                            <span class="d-flex"
                                                                *ngIf="section.get('checkout_time')?.errors?.['required']">Select
                                                                Check-Out Time</span>
                                                        </div>
                                                    </div>
                                                    <ngx-material-timepicker #endTimePicker [format]="24"
                                                        (timeSet)="section.get('checkout_time') && onTimeChange($event, section.get('checkout_time')!)">
                                                    </ngx-material-timepicker>
                                                </div>
                                            </ng-container>
                                        </td>
                                        <td>
                                            <textarea id="comments" class="form-control" placeholder="Enter Comments"
                                                formControlName="comments" [ngClass]="{
                                                    'is-invalid': section.get('comments')?.invalid &&
                                                                (section.get('comments')?.dirty || section.get('comments')?.touched || saveClick)
                                                }">
                                            </textarea>

                                            <div *ngIf="
                                            section.get('comments')?.invalid &&
                                            (section.get('comments')?.dirty || section.get('comments')?.touched || saveClick)"
                                                class="invalid-feedback">

                                                <span class="d-flex"
                                                    *ngIf="section.get('comments')?.errors?.['required']">
                                                    Enter comments
                                                </span>

                                                <span class="d-flex"
                                                    *ngIf="section.get('comments')?.errors?.['maxlength']">
                                                    Maximum length is 250 characters.
                                                </span>

                                                <span class="d-flex"
                                                    *ngIf="section.get('comments')?.errors?.['pattern']">
                                                    Only letters are allowed
                                                </span>
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Submit Buttons -->
                    <div class="d-flex justify-content-end action-bar">
                        <button type="button" class="btn btn-sm cancel" (click)="onCancel()">
                            Cancel
                        </button>
                        <button *ngIf="checkPermission('save') && !approverPage && !paramValue" [disabled]="!formisDisable ||
                            formdata.invalid ||
                            !sections?.length" type="button" class="btn btn-sm submit" (click)="formSubmit('Create')">
                            Create
                        </button>
                        <!-- <button *ngIf="checkPermission( 'edit') && !approverPage && viewData?.showCancelIcon"
                            type="button" class="btn btn-sm submit" (click)="formSubmit('Cancelled')">
                            Cancel Request
                        </button>

                        <button
                            *ngIf="checkPermission(!paramValue ? 'save' : 'edit') && approverPage && viewData?.showApproveIcon"
                            type="button" class="btn btn-sm active m-2" (click)="approveOrReject('Approved')">
                            Approve
                        </button>
                        <button
                            *ngIf="checkPermission(!paramValue ? 'save' : 'edit') && approverPage && viewData?.showRejectIcon"
                            type="button" class="btn btn-sm inactive" (click)="approveOrReject('Rejected')">
                            Reject
                        </button> -->

                        <app-approve-reject *ngIf="viewData" [viewData]="viewData" [approverPage]="approverPage"
                            (approvalAction)="callApprovalApi($event.type, $event.comment)"></app-approve-reject>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>